let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7vJ1d")).then(() => parcelRequire('fcyuR'));